import type { AccountTags, AccountTagSource } from "./types";

/** The plan, subscription status and company tags for a signed-in profile; a null profile gives all undefined, which clears them. */
export function accountTags(profile: AccountTagSource | null): AccountTags {
  if (!profile) return { plan: undefined, subscription_status: undefined, company_id: undefined };
  return {
    plan: profile.subscription?.planId || "none",
    subscription_status: profile.subscription?.isExpired ? "expired" : "active",
    company_id: profile.companyId || undefined,
  };
}

/** Sets the account tags for a signed-in profile through setTag, or clears them all for null. */
export function applyAccountTags(setTag: (key: string, value: string | undefined) => void, profile: AccountTagSource | null): void {
  for (const [key, value] of Object.entries(accountTags(profile))) setTag(key, value);
}
